import React from 'react'
import funnelImage from '../Images/funnelImage.svg'
export default function FunnelChart2({ heading, Data }) {
    const Customcolorcode = {
        "greenish": ["#28A8AB", "#28A8AB"]
    }
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>
                </div>
                <div className="funeel-comp">
                    <div className='custom-funnel-2'>
                        {
                            Data?.length > 0 ? Data?.map((val, id) => {
                                return (
                                    <div className='blockss' style={{width:`calc(100% / ${Data?.length})`}}>
                                        <div style={{ padding: window.innerWidth > 1800 ? "0 10px 275px 10px" :'0 10px 175px 10px', textAlign: 'center' }}>
                                            <h6>{val?.name}</h6>
                                            <h5>{val?.value}</h5>
                                        </div>
                                    </div>
                                )
                            })
                                : ""}

                    </div>
                    <div className='funnel-img'>
                        {
                            Data?.length > 0 ?
                            <img src={funnelImage} width={"100%"} />
                        :""}
                    </div>
                </div>
            </div>
        </>
    )
}
